import styled from 'styled-components';
import background from '../../../../assets/videos/hero_videoclipe.gif';

export const Container = styled.section`
  &.hero {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 2em 15px;
    min-height: 105vh;
    /* background-color: rgba(0, 0, 0, 0.5);

    background: repeating-linear-gradient(
      -55deg,
      rgba(0, 0, 0, 0.4),
      rgba(0, 0, 0, 0.4) 1px,
      rgba(0, 0, 0, 0.5) 1px,
      rgba(0, 0, 0, 0.5) 15px
    ); */

    background: url(${background}) center;
    background-size: cover;

    #hero-sample-video {
      position: absolute;
      right: 0;
      bottom: 0;
      min-width: 100%;
      min-height: 100%;
      object-fit: cover;
      z-index: -1;
      pointer-events: none;
    }

    .hero__content {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      gap: 15px;
      width: 100%;
      max-width: 1300px;
      height: 60vh;
    }

    .hero__caption {
      position: relative;
      z-index: 1;
      margin-right: -94%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      flex: 1;
      width: 100%;
      min-width: 260px;
      max-width: 500px;
      min-height: 300px;
      animation: hero_slide 0.7s ease-in-out forwards;
      animation-delay: 2.5s;
    }

    .hero__title {
      display: inline-flex;
      flex-direction: column;
      font-size: 2.5rem;
      color: #fff;
      text-align: flex-start;
      font-family: 'Montserrat';

      .hero__title-b {
        opacity: 0;
        font-size: 4rem;
        font-weight: bold;
        animation: rendering 0.3s ease-in forwards;
        animation-delay: 0.3s;
      }

      .hero__title-b--second {
        opacity: 0;
        font-size: 4rem;
        font-weight: bold;
        animation: rendering 0.4s ease-in forwards;
        animation-delay: 0.6s;
      }
    }

    .hero__title-message {
      opacity: 0;
      font-size: 4rem;
      font-weight: bold;
      animation: rendering 0.5s ease-in forwards;
      animation-delay: 1s;
    }

    .hero__description {
      opacity: 0;
      color: #fff;
      font-size: 2rem;
      text-align: flex-start;
      font-family: 'Montserrat';
      font-weight: bold;
      margin-left: 3.5rem;
      animation: rendering 0.5s ease-in forwards;
      animation-delay: 2.6s;
    }

    .hero__description2 {
      opacity: 0;
      color: #fff;
      font-size: 1.375rem;
      text-align: flex-start;
      font-family: 'Montserrat';
      font-weight: 500;
      margin-left: 3.5rem;
      margin-top: -1rem;
      margin-bottom: 3rem;
      animation: rendering 0.5s ease-in forwards;
      animation-delay: 2.6s;
    }

    .hero__video-wrapper {
      display: flex;
      align-items: center;
      width: 100%;
      max-width: 700px;
    }

    .hero__video {
      opacity: 0;
      position: relative;
      width: 100%;
      padding-top: 56.25%;
      overflow: hidden;
      animation: rendering 0.5s ease-in forwards;
      animation-delay: 3.5s;

      iframe {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        border-radius: 8px;
      }
    }

    .primary-anchor {
      opacity: 0;
      align-self: flex-start;
      width: 20.625rem;
      height: 5rem;
      background-color: #131e23;
      border-radius: 2.5rem;
      font-family: 'Montserrat';
      font-weight: 700;
      font-size: 1.5rem;
      margin: 0;
      margin-left: 1.875rem;
      animation: rendering 0.5s ease-in forwards;
      animation-delay: 3s;
    }
  }
`;
